import { render, staticRenderFns } from "./KnifeDiskSuspension.vue?vue&type=template&id=7788faba&scoped=true"
import script from "./KnifeDiskSuspension.vue?vue&type=script&lang=js"
export * from "./KnifeDiskSuspension.vue?vue&type=script&lang=js"
import style0 from "./KnifeDiskSuspension.vue?vue&type=style&index=0&id=7788faba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7788faba",
  null
  
)

export default component.exports